import type { RouteRecordRaw } from 'vue-router';
import { Addon, Feature, Permission } from '~/middlewares';
import { adminRoutes } from './admin';
import { authRoutes } from './auth';
import { clientRoutes } from './client';
import { fallbackRoutes } from './fallback';
import { legacyRoutes } from './legacy';
import { serverRoutes } from './server';

export const routes: RouteRecordRaw[] = [...authRoutes, ...clientRoutes, ...serverRoutes, ...adminRoutes, ...legacyRoutes, ...fallbackRoutes];

// Global middlewares with priorities for the existing middleware system
export const globalMiddlewares: PrioritizationMiddleware = [
    [Feature, 10], // Feature checking middleware (high priority)
    [Addon, 9], // Addon checking middleware
    [Permission, 8], // Permission checking middleware
];

export { RouteNames } from '~/types/router';
